module.exports = __webpack_public_path__ + "static/media/04-radio.ae0eaa7b.png";